/**
 * Shared utilities for React Query integration
 *
 * This module provides common utilities used across query modules.
 */

/**
 * Utility to remove undefined/null values from params
 * Used for cleaning query keys and preventing unnecessary cache misses
 */
export const removeEmpty = <T extends Record<string, unknown>>(obj?: T): Record<string, unknown> => {
    if (!obj) return {};
    return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v !== undefined && v !== null));
};
